import PropTypes from 'prop-types';
import React from 'react';
import {FundedProjectCard} from "./FundedProjectCard.js";
import {FUNDED_PROJECTS_PAGE_COUNT} from "./donorProfileConstants.js";
import {LoadingEllipsis} from '../common/LoadingEllipsis.js';

export class FundedProjects extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
	}

	renderProjectCard(project){
		let donationDetails = this.props.fundedProjectDonations.filter(d => d["projectId"] == project.id)[0]
		return <FundedProjectCard key={project.id} project={project} donationDate={donationDetails.donationDate} anonymous={donationDetails.anonymous}/>
	}

	renderAllProjectCards(){
		return(
			<div>
				<div className="teacher-quotation-grid">
					{this.props.fundedProjects.map(p => this.renderProjectCard(p))}
				</div>
				{this.props.loadingFullyFundedProjects && <LoadingEllipsis />}
			</div>

		);
	}

	renderShowMoreButton(){
		if(!this.props.loadingFullyFundedProjects && this.props.fundedProjects.length % FUNDED_PROJECTS_PAGE_COUNT === 0 && !this.props.doantionsEndReached){
			return(
					<a className="button-secondary" onClick={this.props.showMoreFundedProjects}>Show more teachers</a>
			)
		}
	}

	render() {
		let multipleTeachersSupported =  this.props.numTeachersSupported > 1;
		let multipleProjectsSupported = multipleTeachersSupported || this.props.fundedProjects.length > 1;
		return (
				<section className="projects-past">
					<h2>{this.props.viewingOwnPage ? "You have" : this.props.displayName + " has"} helped {this.props.numTeachersSupported} {multipleTeachersSupported ? "teachers" : "teacher"} fund their {multipleProjectsSupported ? "projects" : "project"}</h2>
					{this.renderAllProjectCards()}
					{this.renderShowMoreButton()}
					{this.props.viewingOwnPage && <a className="giving-history-link" href={secureBaseURL + "common/donation-info.html"}>See your giving history</a>}
				</section>
		);
	}
}

FundedProjects.propTypes = {
	displayName: PropTypes.string.isRequired,
	numTeachersSupported: PropTypes.number,
	fundedProjects: PropTypes.array,
	fundedProjectDonations: PropTypes.array,
	viewingOwnPage: PropTypes.bool.isRequired,
	showMoreFundedProjects: PropTypes.func.isRequired,
	loadingFullyFundedProjects: PropTypes.bool,
	doantionsEndReached: PropTypes.bool
};
